<style lang="scss" src="./App.scss"></style>

<template>
    <div v-bind:class="{'scroll-active': scrollActive}">
        

        <AppBase ref="appbase"></AppBase>

        <!-- main view -->        
        <div class="scrollbar-container">
            <div class="scrollbar c-hover" id="scrollbar"></div>
        </div>
        <div class="scroll-zone" ref="scrollZone">
            <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                <router-view class="app-router animated" ref="routerRef"></router-view>
            </transition>
        </div>
                
        <div class="cursor" ref="cursor">
<!--            <span class="cursor-text">{{cursorText}}</span>-->
        </div>

    </div>
</template>

<script>
    
    import AppBase from './components/AppBase/AppBase.vue'
    import SmoothScroll from './assets/js/smoothScroll.js'

    export default {
        
        components: {
            AppBase
        },
        
        data() {
            return {
                scrollActive: false,
                firstLoad: true,
                isMobile: false,
                windowHeight: window.innerHeight,
                mouseX: 0,
                mouseY: 0,
                isProjectsScrolled: false,
                cursorActive: false,
                waveElements: false,
                wavesActive: false
            }
        },        
        
        beforeMount() {
            this.checkIfMobile()
        },
        
        mounted() {
            this.listenEvents()
            
            if (!this.isMobile) {
                this.initCustomCursor()
                this.initTextHover()                
            }
        },

        updated() {
            this.$refs.appbase.setRouteTraductionNames()
        },
        
        methods: {
            
            listenEvents() {
                window.addEventListener('resize', _.throttle(this.resize, 200))
            },

            unlistenEvents() {
                window.removeEventListener('resize', _.throttle(this.resize, 200))
            },
            
            resize() {
                if (this.scrollActive) {
                    this.smoothScroll.onResize()
                }
                this.deviceResize()
            },
                        
            resetScroll() {
                this.smoothScroll.destroy()
                this.scrollActive = false
            },
            
            launchSmoothScroll() {
                this.smoothScroll = new SmoothScroll(.1, {
                    el: this.$refs.scrollZone,
                    mouseMultiplier: .4
                })
                this.smoothScroll.init()
                this.scrollActive = true
            },
            
            checkIfMobile() {
                if (window.innerWidth < 1025) {
                    this.isMobile = true
                    document.body.style.overflow = 'visible'
                } else {
                    this.isMobile = false
                }
            },
            
            deviceResize() {
                this.windowHeight = window.innerHeight;
                
                if (window.innerWidth < 1025) {

                    this.isMobile = true
                    document.body.style.overflow = 'visible'
                    
                    if (this.scrollActive) {
                        this.smoothScroll.applyTransform(this.$refs.scrollZone, 0)
                        this.smoothScroll.destroy()
                        this.scrollActive = false
                    }
                    
                    if (this.cursorActive) {
                        this.stopCustomCursor()
                    }
                    
                } else {
                    this.isMobile = false                    
                    document.body.style.overflow = 'hidden'
                    
                    if (!this.scrollActive) {                        
                        
                        if (!this.$route.name.includes('projects_component')) {
                            document.documentElement.scrollTop = 0
                            document.body.scrollTop = 0
                            this.launchSmoothScroll()
                        }
                    }
                    
                    if (!this.cursorActive) {
                        this.initCustomCursor()
                    }
                    
                    if (!this.wavesActive) {
                        this.initTextHover()
                    }
                }
            },
            
            initCustomCursor() {
                if (!this.isMobile && !this.cursorActive && typeof(this.$refs.cursor.classList) !== 'undefined') {
                    window.addEventListener('mousemove', this.moveCursor)
                    this.cursorActive = true
                }
            },
            
            stopCustomCursor() {
                if (this.cursorActive) {                    
                    window.removeEventListener('mousemove', this.moveCursor)
                    this.cursorActive = false
                }
            },
            
            moveCursor(event) {
                if (!this.$refs.cursor.classList.contains('is-active')) {
                    this.$refs.cursor.classList.add('is-active')
                }
                
                this.mouseX = event.clientX
                this.mouseY = event.clientY
                
                this.$refs.cursor.style.left = event.clientX + "px"
                this.$refs.cursor.style.top = event.clientY + "px"
                
                if (this.mouseY <= 2 || this.mouseY >= this.windowHeight - 2 || document.hidden) {
                    this.$refs.cursor.classList.remove('is-active')
                } else {
                    this.$refs.cursor.classList.add('is-active')
                }
                
                // première condition est un fix ie11
                if (typeof(event.target.classList) !== 'undefined') {                    
                    if (event.target.classList.contains('c-hover')) {
                        this.$refs.cursor.classList.add('l-hover')
                        this.$refs.cursor.classList.remove('l-arrowRight')
                        this.$refs.cursor.classList.remove('l-arrowLeft')

                    } else if (event.target.classList.contains('c-arrowLeft')) {
                        this.$refs.cursor.classList.add('l-arrowLeft')
                        this.$refs.cursor.classList.remove('l-hover')
                        this.$refs.cursor.classList.remove('l-arrowRight')                                        

                    } else if (event.target.classList.contains('c-arrowRight')) {                    
                        this.$refs.cursor.classList.add('l-arrowRight')
                        this.$refs.cursor.classList.remove('l-hover')
                        this.$refs.cursor.classList.remove('l-arrowLeft')                    

                    } else {
                        this.$refs.cursor.classList.remove('l-arrowRight')
                        this.$refs.cursor.classList.remove('l-hover')
                        this.$refs.cursor.classList.remove('l-arrowLeft')                   
                    }
                }
            },
            
            initTextHover() {
                this.waveElements = Array.prototype.slice.call(document.getElementsByClassName('hover-wave'))
                var self = this;
                
                this.waveElements.forEach(function(element) {
                    
                    if (!element.classList.contains('wave-ready')) {                        
                        element.classList.add('wave-ready')

                        element.addEventListener("mouseenter", self.waveAnimation.bind(null, element))
                    }
                })
                
                this.wavesActive = true
            },
            
            waveAnimation(element, event) {
                if (!this.isMobile) {                    
                    TweenMax.staggerTo(element.querySelectorAll("span"), 0.2, {
                        x: 5,
                        y: 5,
                        autoAlpha: 0
                    }, 0.05)
                    TweenMax.staggerTo(element.querySelectorAll("span"), 0, {
                        x: -5,
                        y: -5,
                        autoAlpha: 0,
                        delay: 0.2
                    }, 0.05)
                    TweenMax.staggerTo(element.querySelectorAll("span"), 0.2, {
                        x: 0,
                        y: 0,
                        autoAlpha: 1,
                        delay: 0.2
                    }, 0.05)
                }
            }
            
        }
        
    }
    
</script>


// WEBPACK FOOTER //
// src/App.vue